'use client'

import { Data, Effect, pipe } from 'effect'
import type { Effect as EffectType } from 'effect/Effect'
import { AuthenticationErrorType } from '@/lib/apis/types'
import { loginWithPostHogSession } from '@/lib/apis/authentication-client'

export class AuthenticationError extends Data.TaggedError(
  'AuthenticationError',
)<{
  type: AuthenticationErrorType
}> {}

export class NetworkError extends Data.TaggedError('NetworkError')<{
  cause: unknown
}> {}

interface AuthInfo {
  readonly username: string
  readonly password: string
  readonly redirect?: string
}

export const login = ({
  username,
  password,
  redirect,
}: AuthInfo): EffectType<null, AuthenticationError | NetworkError> => {
  const data = new FormData()
  data.append('username', username)
  data.append('password', password)
  data.append('redirect', redirect ? 'true' : 'false')

  if (redirect) {
    data.append('redirectTo', redirect)
  }

  return pipe(
    Effect.tryPromise({
      try: () => loginWithPostHogSession(data),
      catch: (cause) => new NetworkError({ cause }),
    }),

    Effect.andThen((type) =>
      type
        ? Effect.fail(new AuthenticationError({ type }))
        : Effect.succeed(null),
    ),
  )
}
